const collaboratorFields = require('../settings/collaboratorFields.json');
const contactFields = require('../settings/contactFields.json');
const groupFields = require('../settings/groupFields.json');
const externalAccessFields = require('../settings/externalAccessFields.json');

const rulesDefined = {
  noSpaces: value => {
    const pattern = /\s/g;
    return !pattern.test(value) || "Ne doit pas contenir d'espaces";
  },
  wordsWithOnlyLetters: value => {
    const pattern = /^[a-zA-Z+àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ -]*$/g;
    return pattern.test(value) || 'Ne doit contenir que des lettres';
  },
  phoneNumber: value => {
    const pattern = /^\+\d{8,}$/g;
    if (!value) {
      return true;
    }
    return pattern.test(value) || 'Le numéro doit être valide';
  },
  email: value => {
    const pattern = /^(?=[^\s@]{0,64}@)[^\s@]+@[^\s@]+\.[^\s@.]+$/;
    // in case the string is null no need to check because is not required
    if (!value) {
      return true;
    }
    return pattern.test(value) || 'Email Invalide';
  }
};

const fieldRules = fieldSettings => {
  const rules = [];

  // Check rules
  if (fieldSettings.required) {
    rules.push(v => {
      const isEmpty = typeof v === 'string' ? v.trim().length === 0 : false;
      return (!!v && !isEmpty) || `${fieldSettings.label} est requis`;
    });
  }

  if (fieldSettings.counter) {
    rules.push(v => !v || (v && v.length <= fieldSettings.counter) || `Le ${fieldSettings.label} doit comporter ${fieldSettings.counter} caractères ou moins`);
  }

  if (fieldSettings.rules) {
    // Custom rules
    fieldSettings.rules.forEach(ruleName => {
      if (rulesDefined[ruleName]) {
        rules.push(rulesDefined[ruleName]);
      }
    });
  }

  return rules;
};

// To fill collaborator form
const collaboratorFieldsProperties = field => {
  const fieldSettings = collaboratorFields[field];

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

// To fill contacts form
const contactFieldsProperties = field => {
  const fieldSettings = contactFields[field];

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

// To fill groups form
const groupFieldsProperties = field => {
  const fieldSettings = groupFields[field];

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

// To fill external Access form
const externalAccessFieldsProperties = field => {
  const fieldSettings = externalAccessFields[field];

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

export { collaboratorFieldsProperties, contactFieldsProperties, groupFieldsProperties, externalAccessFieldsProperties };
